module.exports = require("@swa-ui/core/src/GroupedRow/GroupedRow.module.scss");